import { useTranslation } from "react-i18next";
import VMVMetier from '../../components/static-blocks/VMVMetier/VMVMetier';
import VMVValeurs from '../../components/static-blocks/VMVValeurs/VMVValeurs';
import styles from './Cloture.module.scss';

const Cloture = () => {
    const { t } = useTranslation();
    return (
        <article className={styles.cloture_container}>
            <article className={styles.cloture_header}>
                <h1>{t("titles.visMyLife")}</h1>
                <h2>{t("titles.registrationClosed", { year: new Date().getFullYear() })}</h2>
                <div className={styles.gradient_div}>
                    <p>
                        <span>{t("cloture.cantRegister")}</span>
                        {t("cloture.registrationsClosed")}
                        <br />
                        {t("cloture.tryNextYear", { year: new Date().getFullYear() + 1 })}
                        <br />
                    </p>
                    <p>
                        {t("cloture.thankYou")}
                        <br />
                        {t("cloture.talkSoon")}
                        <br />
                    </p>
                    <p>{t("cloture.values")}</p>
                </div>
            </article>
            <VMVValeurs />
        </article>
    );
};

export default Cloture;